import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Location from './Location'
import Validation from '../dispositionValidation'
import TransferAction from 'Store/Component/Transfer/TransferAction';
import { getStates } from 'Store/Organization/States/StatesAction'
import { getCities } from 'Store/Organization/Cities/CitiesAction'
import { useParams } from 'react-router-dom';
import RequisitionAction from 'Store/Component/Requisition/RequisitionAction';
import { CONSTANTS } from 'client/utils/constants';
import { getAddressDetails, setAddressDetails } from 'Store/Organization/AutoCompleteAddressDetails/AddressDetailsAction';
import { getAddressDropDownList } from 'Store/Organization/AutoCompleteAddressSearch/AddressSearchAction';

const LocationContainer = (props: any) => {
  const {
    setLocationAssetValid,
    isRevertChanges    
  } = props
  const dispatch = useDispatch();

  const [addressDropDownListTemp, setAddressDropDownListTemp] = useState<any>();
  const [addressListLoad, setAddressListLoad] = useState<any>();
  const [addressSearchText, setAddressSearchText] = useState<any>();
  const [cityOption, setCityOption] = useState<any>([])
  const [stateList, setStateList] = useState<any>([]);
  const [cityList, setCityList] = useState<any>([]);
  const [sameAsBranch, setSameAsBranch] = useState<boolean>(false)
  const DispositionLocationFieldRef = props?.DispositionLocationFieldRef

  const initialAssetLocation = {
    assetLocationName: null,
    assetLocationContactName: '',
    assetLocationEmail: '',
    assetLocationContactPhone: null,
    assetLocationAddress1: '',
    assetLocationAddress2: '',
    assetLocationZip: null,
    assetLocationCity: '',
    assetLocationState: ''
  }

  useEffect(() => {
    dispatch(getStates())
  }, [])

  useEffect(() => {
     props.AssetDispostionFieldRef?.current[2]?.focus();
  }, [])


  const [assetLocation, setAssetLocation] = useState<any>(initialAssetLocation)

  const {
    selectedBranch,
    BranchDetails,
    branchTypeDropdown,
    dispositionData,
    isResetClicked,
    addressDropDownList,
    locationAddressDetails
  }: any = useSelector((state?: any) => ({
    selectedBranch: state.TransferReducer.selectedBranch,
    BranchDetails: state.GetBranchDetails.BranchDetails,
    branchTypeDropdown: state.CostCenter.costCenterDropDown,
    dispositionData: state.TransferReducer.dispositionList,
    isResetClicked: state.TransferReducer.isResetClicked,
    addressDropDownList: state.AddressDropDownReducer.locationAddressDropDownList,
    locationAddressDetails: state.AddressDetailReducer.locationAddressDetails
  }));

  useEffect(() => {
    const addDropdownList = addressDropDownList?.map((item: any, index: number) =>
    ({ text: item.description, label: item.description, value: item.place_id, key: item.place_id })
  );
   setAddressDropDownListTemp(addDropdownList)
   setAddressListLoad(false)
  },[addressDropDownList])

  useEffect(() => {
    setAssetLocation(initialAssetLocation)
    setSameAsBranch(false)
  }, [dispositionData.assetDispositionChoice])

  useEffect(() => {
    if (isResetClicked) {
      setCityList([]);
      setCityOption([])
      setStateList([]);
      setAssetLocation(initialAssetLocation);
      setSameAsBranch(false)
      setAddressSearchText("")
      setAddressDropDownListTemp([])
      dispatch(setAddressDetails({}, 'location'))
    }
  }, [isResetClicked])

  useEffect(() => {
    if (sameAsBranch && (selectedBranch || dispositionData) && !!selectedBranch?.branchName) {
      const selectedBranchDetails = branchTypeDropdown.find((branchItem: any) => branchItem?.branchName === selectedBranch.branchName)
      if (sameAsBranch && dispositionData?.assetLocationContactName) {
        setAssetLocation({
          ...assetLocation,
          assetLocationName: dispositionData.assetLocationName?.trim(),
          assetLocationContactPhone: dispositionData.assetLocationContactPhone,
          assetLocationAddress1: dispositionData.assetLocationAddress1?.trim(),
          assetLocationAddress2: dispositionData.assetLocationAddress2?.trim(),
          assetLocationZip: dispositionData.assetLocationZip?.trim(),
          assetLocationState: dispositionData.assetLocationState?.trim(),
          assetLocationCity: dispositionData.assetLocationCity?.trim()
        })
      } else {
        setAssetLocation({
          ...assetLocation,
          assetLocationName: selectedBranchDetails.branchName?.trim(),
          assetLocationContactPhone: selectedBranchDetails.branchPhone,
          assetLocationAddress1: selectedBranchDetails.branchAddress3?.trim(),
          assetLocationAddress2: selectedBranchDetails.branchAddress2?.trim(),
          assetLocationZip: selectedBranchDetails.branchZip?.trim(),
          assetLocationState: selectedBranchDetails.branchState?.trim(),
          assetLocationCity: selectedBranchDetails.branchCity?.trim()
        })
    }
    } else if (sameAsBranch && (!selectedBranch || !selectedBranch.branchZip || !selectedBranch.branchState)) {
      const branchDetails = branchTypeDropdown.find((branchItem: any) => branchItem?.branchName === BranchDetails.name)
      setAssetLocation({
        ...assetLocation,
        assetLocationName: branchDetails.branchName?.trim(),
        assetLocationContactPhone: branchDetails.branchPhone,
        assetLocationAddress1: branchDetails.branchAddress3?.trim(),
        assetLocationAddress2: branchDetails.branchAddress2?.trim(),
        assetLocationZip: branchDetails.branchZip?.trim(),
        assetLocationState: branchDetails.branchState?.trim(),
        assetLocationCity: branchDetails.branchCity?.trim()
      })
    } else {
      setAssetLocation(initialAssetLocation)
      setCityList([])
      setStateList([])
    }
  }, [sameAsBranch])


  useEffect(()=>{
    updateAllState()
  },[dispositionData?.assetLocationContactName])

  useEffect(() => {
    if (stateList?.key && typeof stateList?.key === 'number' ) {
      dispatch(getCities(stateList.key))
    }
  }, [stateList])

  let { id } = useParams();

  useEffect(() => {
    if (id) {
      updateAllState();
    }
  }, [])

  useEffect(() => {
    if (isRevertChanges) {
      updateAllState();
    }
  }, [isRevertChanges])

  const updateAllState = () => {
    setCityList({
      label: dispositionData?.assetLocationCity,
      key: dispositionData?.assetLocationCity,
      value: dispositionData?.assetLocationCity,
      text: dispositionData?.assetLocationCity
    });
    setStateList({
      label: dispositionData?.assetLocationState,
      key: dispositionData?.assetLocationState,
      value: dispositionData?.assetLocationState,
      text: dispositionData?.assetLocationState
    });
    setAssetLocation({
      assetLocationName: dispositionData.assetLocationName,
      assetLocationContactName: dispositionData.assetLocationContactName,
      assetLocationEmail: dispositionData.assetLocationEmail,
      assetLocationContactPhone: dispositionData.assetLocationContactPhone,
      assetLocationAddress1: dispositionData.assetLocationAddress1,
      assetLocationAddress2: dispositionData.assetLocationAddress2,
      assetLocationZip: dispositionData.assetLocationZip,
      assetLocationCity: dispositionData.assetLocationCity,
      assetLocationState: dispositionData.assetLocationState
    })
    {(dispositionData.assetLocationName === selectedBranch?.branchName || dispositionData.assetLocationName === BranchDetails?.name) && setSameAsBranch(dispositionData.assetLocationName === selectedBranch?.branchName || dispositionData.assetLocationName === BranchDetails?.name)}
  }

  const isValidateAssetLocation = (data: any) => {
    if (
      data.assetLocationName !== "" && data.assetLocationName !== null &&
      data.assetLocationContactName !== "" && data.assetLocationContactName !== null &&
      data.assetLocationEmail !== "" && data.assetLocationEmail !== null &&
      data.assetLocationContactPhone !== "" && data.assetLocationContactPhone !== null &&
      data.assetLocationAddress1 !== "" && data.assetLocationAddress1 !== null &&
      data.assetLocationCity !== "" && data.assetLocationCity !== null &&
      data.assetLocationState !== "" && data.assetLocationState !== null &&
      data.assetLocationZip !== "" && data.assetLocationZip !== null
    ) {
      return false
    }
    return true
  }

  const toggleSameAsBranch = () => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    setSameAsBranch(!sameAsBranch)
    if(sameAsBranch){
      setLocationAssetValid(true)
    }
    dispatch(TransferAction.setIDisposition({
      ...dispositionData,
      assetLocationNameError: '',
      assetLocationContactNameError: '',
      assetLocationEmailError: '',
      assetLocationContactPhoneError: '',
      assetLocationAddress1Error: '',
      assetLocationAddress2Error: '',
      assetLocationCityError: '',
      assetLocationStateError: '',
      assetLocationZipError: ''
    }))
    dispatch(TransferAction.setIsResetClicked(false))
  }

  const assetLocationNameOnChange = (e: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    const assetLocationTemp = JSON.parse(JSON.stringify(assetLocation))
    assetLocationTemp.assetLocationName = e.target.value
    let error = { ...Validation.ValidateAssetLocationName(assetLocationTemp, { ...assetLocationTemp }) };
    setAssetLocation(assetLocationTemp)
    setLocationAssetValid(isValidateAssetLocation({ ...dispositionData, ...error }))
    dispatch(TransferAction.setIDisposition({
      ...dispositionData,
      ...assetLocationTemp,
      ...error
    }))
    dispatch(TransferAction.setIsResetClicked(false))
    setTimeout(()=>{
      if (e.target.name == CONSTANTS.ASSET_LOCATION_NAME){
        DispositionLocationFieldRef?.current[1]?.focus();
      }
    },3000)
  }

  const assetLocationContactNameOnChange = (e: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    const assetLocationTemp = JSON.parse(JSON.stringify(assetLocation))
    assetLocationTemp.assetLocationContactName = e.target.value
    let error = { ...Validation.ValidateName(assetLocationTemp, { ...assetLocationTemp }) };
    setAssetLocation(assetLocationTemp)
    setLocationAssetValid(isValidateAssetLocation({ ...dispositionData, ...error }))
    dispatch(TransferAction.setIDisposition({
      ...dispositionData,
      ...assetLocationTemp,
      ...error
    }))
    dispatch(TransferAction.setIsResetClicked(false))
    setTimeout(()=>{
      if (e.target.name == CONSTANTS.ASSET_LOCATION_CONTACT_NAME){
        DispositionLocationFieldRef?.current[2]?.focus();
      }
    },3000)
  }

  const assetLocationEmailOnChange = (e: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    const assetLocationTemp = JSON.parse(JSON.stringify(assetLocation))
    assetLocationTemp.assetLocationEmail = e.target.value
    let error = { ...Validation.ValidateEmailAddress(assetLocationTemp, { ...assetLocationTemp }) };
    setAssetLocation(assetLocationTemp)
    setLocationAssetValid(isValidateAssetLocation({ ...dispositionData, ...error }))
    dispatch(TransferAction.setIDisposition({
      ...dispositionData,
      ...assetLocationTemp,
      ...error
    }))
    dispatch(TransferAction.setIsResetClicked(false))
    setTimeout(()=>{
      if (e.target.name == CONSTANTS.ASSET_LOCATION_EMAIL){
        DispositionLocationFieldRef?.current[3]?.focus();
      }
    },3000)
  }

  const assetLocationContactPhoneOnChange = (e: any, value: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    const assetLocationTemp = JSON.parse(JSON.stringify(assetLocation))
    assetLocationTemp.assetLocationContactPhone = value
    let error = { ...Validation.ValidatePhone(assetLocationTemp, { ...assetLocationTemp }) };
    setAssetLocation(assetLocationTemp)
    setLocationAssetValid(isValidateAssetLocation({ ...dispositionData, ...error }))
    dispatch(TransferAction.setIDisposition({
      ...dispositionData,
      ...assetLocationTemp,
      ...error
    }))
    dispatch(TransferAction.setIsResetClicked(false))
    setTimeout(()=>{
      if (e.target.name == CONSTANTS.ASSET_LOCATION_CONTACT_PHONE){
        DispositionLocationFieldRef?.current[4]?.focus();
      }
    },3000)
  }

  const assetLocationAddress2OnChange = (e: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    const assetLocationTemp = JSON.parse(JSON.stringify(assetLocation))
    assetLocationTemp.assetLocationAddress2 = e.target.value
    let error = { ...Validation.ValidateAddress2(assetLocationTemp, { ...assetLocationTemp }) };
    setAssetLocation(assetLocationTemp)
    dispatch(TransferAction.setIDisposition({
      ...dispositionData,
      ...assetLocationTemp,
      ...error
    }))
    dispatch(TransferAction.setIsResetClicked(false))
    setTimeout(()=>{
      if (e.target.name == CONSTANTS.ASSET_LOCATION_ADDRESS2){
        DispositionLocationFieldRef?.current[7]?.focus();
      }
    },3000)
  }

  const assetLocationZipOnChange = (e: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    const assetLocationTemp = JSON.parse(JSON.stringify(assetLocation))
    assetLocationTemp.assetLocationZip = e.target.value
    let error = { ...Validation.ValidateZip(assetLocationTemp, { ...assetLocationTemp }) };
    setAssetLocation(assetLocationTemp)
    setLocationAssetValid(isValidateAssetLocation({ ...dispositionData, ...error }))
    dispatch(TransferAction.setIDisposition({
      ...dispositionData,
      ...assetLocationTemp,
      ...error
    }))
    dispatch(TransferAction.setIsResetClicked(false))

  }

  const cityOnChange = (e: any, item?: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    const assetLocationTemp = JSON.parse(JSON.stringify(assetLocation))
    assetLocationTemp.assetLocationCity = e.target.value
    let error = { ...Validation.ValidateCity(assetLocationTemp, { ...assetLocationTemp }) };
    setAssetLocation(assetLocationTemp)
    setLocationAssetValid(isValidateAssetLocation({ ...dispositionData, ...error }))
    dispatch(TransferAction.setIDisposition({
      ...dispositionData,
      ...assetLocationTemp,
      ...error
    }))
    dispatch(TransferAction.setIsResetClicked(false))

  }

  const stateOnChange = (e: any, item?: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    const assetLocationTemp = JSON.parse(JSON.stringify(assetLocation))
    assetLocationTemp.assetLocationState = e.target.value
    let error = { ...Validation.ValidateState(assetLocationTemp, { ...assetLocationTemp }) };
    setAssetLocation(assetLocationTemp)
    setLocationAssetValid(isValidateAssetLocation({ ...dispositionData, ...error }))
    setCityList([])
    dispatch(TransferAction.setIDisposition({
      ...dispositionData,
      ...assetLocationTemp,
      ...error
    }))
    dispatch(TransferAction.setIsResetClicked(false))

  }

  useEffect(() => {
    if (addressSearchText?.length > 3) {
      setAddressListLoad(true)
      dispatch(getAddressDropDownList(addressSearchText.replace(/[^\w\s]/gi, ""), 'location'));
    }
  }, [addressSearchText])

  const filterLocationOptionAddress1 = (value: any, action: any, id: any) => {
    if (action.action === "input-change") {
      setAddressSearchText(value);
      dispatch(RequisitionAction.setIsChangesOccured(true))
      const assetLocationTemp = JSON.parse(JSON.stringify(assetLocation))
      assetLocationTemp.assetLocationAddress1 = value
      let error = { ...Validation.ValidateAddress1(assetLocationTemp, { ...assetLocationTemp }) };
      setAssetLocation(assetLocationTemp)
      setLocationAssetValid(isValidateAssetLocation({ ...dispositionData, ...error }))
      dispatch(TransferAction.setIDisposition({
        ...dispositionData,
        ...assetLocationTemp,
        ...error
      }))
      dispatch(TransferAction.setIsResetClicked(false))
    }
  };

  const assetLocationAddress1OnChange = (e: any, item?: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
    dispatch(getAddressDetails(e?.key, 'location'))
    dispatch(TransferAction.setIsResetClicked(false))
  }

  useEffect(() => {
    if (locationAddressDetails?.hasOwnProperty("address1") || locationAddressDetails?.hasOwnProperty("address2")) {
      setAddressSearchText('')
      let assetLocationTemp = { ...dispositionData }
      assetLocationTemp.assetLocationAddress1 = locationAddressDetails?.address1
      assetLocationTemp = { ...Validation.ValidateAddress1(assetLocationTemp, { ...assetLocationTemp }) };
      assetLocationTemp.assetLocationAddress2 = locationAddressDetails?.address2 
      assetLocationTemp = { ...Validation.ValidateAddress2(assetLocationTemp, { ...assetLocationTemp }) };
      assetLocationTemp.assetLocationZip = locationAddressDetails?.postalCode
      assetLocationTemp = { ...Validation.ValidateZip(assetLocationTemp, { ...assetLocationTemp }) };
      assetLocationTemp.assetLocationCity = locationAddressDetails?.city
      assetLocationTemp = { ...Validation.ValidateCity(assetLocationTemp, { ...assetLocationTemp }) };
      assetLocationTemp.assetLocationState = locationAddressDetails?.state
      assetLocationTemp = { ...Validation.ValidateState(assetLocationTemp, { ...assetLocationTemp }) };
      isValidateAssetLocation(assetLocationTemp)
      setAssetLocation(assetLocationTemp)
      dispatch(TransferAction.setIDisposition(assetLocationTemp))
      dispatch(setAddressDetails({}, 'location'))
    }
  }, [locationAddressDetails])

  return (
    <Location
      cityList={cityList}
      cityOption={cityOption}
      cityOnChange={cityOnChange}
      stateOnChange={stateOnChange}
      stateList={stateList}
      toggleSameAsBranch={toggleSameAsBranch}
      sameAsBranch={sameAsBranch}
      assetLocation={assetLocation}
      assetLocationNameOnChange={assetLocationNameOnChange}
      assetLocationContactNameOnChange={assetLocationContactNameOnChange}
      assetLocationEmailOnChange={assetLocationEmailOnChange}
      assetLocationContactPhoneOnChange={assetLocationContactPhoneOnChange}
      assetLocationAddress1OnChange={assetLocationAddress1OnChange}
      assetLocationAddress2OnChange={assetLocationAddress2OnChange}
      assetLocationZipOnChange={assetLocationZipOnChange}
      dispositionData={dispositionData}
      DispositionLocationFieldRef={DispositionLocationFieldRef}
      AssetDispostionFieldRef={props?.AssetDispostionFieldRef}
      addressSearchText = {addressSearchText}
      addressListLoad = {addressListLoad}
      addressDropDownListTemp = {addressDropDownListTemp}
      filterLocationOptionAddress1 = {filterLocationOptionAddress1}
    />
  )
}

export default LocationContainer